import { InjectionToken } from '@angular/core';
import { Dictionary } from '../models/dictionary.model';

/**
 * An Injection token that can be used to specify error messages etc.
 *
 * @example {
 *  'required': 'Required message here',
 *  'invalid': 'Invalid message here'
 * }
 * */
export const APX_ERRORS_CONFIG = new InjectionToken<Dictionary<string>>('apx-errors-config');
